import { TargetingDropdownSection } from '../../../shared/ReadOnlyTargetingDropdown/TargetingDropdownSection';
import { getOptionName } from '../../constants';
import type { CommonItemPropsType } from '../../types';
import { IntersectItems } from './IntersectItems';

export const SeriesItem = ({
  type,
  onOpenDrawerClick,
  showDimensionChipLine,
  hideButtons,
  selectedParams,
  onChange,
  onRemove,
  readonly,
  dimensionChipLine,
  targetingParams,
  optionsCount,
  isDisabled,
  disabledReasonMessage,
}: CommonItemPropsType) => {
  return (
    <>
      <TargetingDropdownSection
        name={getOptionName(type)}
        hideButtons={hideButtons}
        isEmpty={!selectedParams.includes(type)}
        onOpenDrawerClick={onOpenDrawerClick}
        onRemove={onRemove}
        hasOptionsSelected={!!optionsCount && optionsCount > 0}
        isDisabled={isDisabled}
        disabledReasonMessage={disabledReasonMessage}
      >
        <IntersectItems
          targetingParams={targetingParams}
          type={type}
          readonly={readonly}
          onChange={onChange}
          disabledReasonMessage={disabledReasonMessage}
        />
      </TargetingDropdownSection>
      {showDimensionChipLine && dimensionChipLine(selectedParams.includes(type))}
    </>
  );
};
